module.exports = __webpack_public_path__ + "img/app2.bba24bae.png";